/* VPV Hero — optional slideshow.

   When a hero has 2+ Hero Group slides, drive it with Impulse's own slideshow
   mechanism (theme.Slideshow → Flickity): drag on desktop, swipe on mobile,
   page dots, NO arrows. A single slide stays static (no slider). */
(function () {
  function optsFor(root) {
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    return {
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      adaptiveHeight: true,
      cellAlign: 'left',
      autoPlay: autoplay ? speed : false
    };
  }

  function wrapperFor(root) {
    return root.closest('.shopify-section') || root;
  }

  function destroyInstance(wrapper) {
    if (wrapper._vpvHeroSlideshow && typeof wrapper._vpvHeroSlideshow.destroy === 'function') {
      wrapper._vpvHeroSlideshow.destroy();
    }
    wrapper._vpvHeroSlideshow = null;
  }

  function initHero(root) {
    var wrapper = wrapperFor(root);

    // Admin "Unwrap slideshow in the customizer only" — keep it un-initialized
    // (slides stack via CSS); make sure nothing is still running.
    if (root.dataset.editorStack === 'true') {
      destroyInstance(wrapper);
      return;
    }

    var count = parseInt(root.dataset.slideCount, 10) || 0;
    if (count < 2) return; // single slide → static

    var slides = root.querySelector('.vpv-hero__slides');
    if (!slides || slides.classList.contains('flickity-enabled')) return;
    if (typeof theme === 'undefined' || typeof theme.Slideshow !== 'function') return;

    // Tear down any previous instance for this section (editor re-render) — the
    // reference is parked on the persistent .shopify-section wrapper.
    destroyInstance(wrapper);
    wrapper._vpvHeroSlideshow = new theme.Slideshow(slides, optsFor(root));
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.vpv-hero[data-vpv-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor lifecycle.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var wrapper = e.target;
    if (wrapper._vpvHeroSlideshow && typeof wrapper._vpvHeroSlideshow.destroy === 'function') {
      wrapper._vpvHeroSlideshow.destroy();
      wrapper._vpvHeroSlideshow = null;
    }
  });
})();
